import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { useStateValue } from '@State'
import { ltiOrgKeyManagement as endpoints } from '@URLS'

export const DevKeyForm = props => {
  const [currentState, dispatch] = useStateValue()

  const [appName, updateAppName] = useState('')
  const [trustedUrl, updateTrustedUrl] = useState('')
  const [appId, updateAppId] = useState('')
  const [appKey, updateAppKey] = useState('')
  const [entityDomain, updateEntityDomain] = useState('')

  const handleAppNameChange = e => {
    updateAppName(e.target.value)
  }

  const handleTrustedUrlChange = e => {
    updateTrustedUrl(e.target.value)
  }

  const handleAppIdChange = e => {
    updateAppId(e.target.value)
  }

  const handleAppKeyChange = e => {
    updateAppKey(e.target.value)
  }

  const handleEntityDomainChange = e => {
    updateEntityDomain(e.target.value)
  }

  const AddDevKey = async () => {
    try {
      let resp = await client.post(
        endpoints.addDevKey({ orgId: props.organization.id }),
        {
          appName: appName,
          trustedUrl: trustedUrl,
          appId: appId,
          appKey: appKey,
          entityDomain: entityDomain,
        }
      )
      toast.success("Successfully added new context.")
      props.toggle(false)
      props.setOrganization(resp.data.organization)
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      console.log(err)
      toast.error("There was an error trying to create a new context.")
    }
  }

  return (
    <Fragment>
      <Form.Group controlId="appName">
        <Form.Label>App Name</Form.Label>
        <Form.Control
          type="text"
          onChange={handleAppNameChange}
          value={appName}
        />
      </Form.Group>
      <Form.Group controlId="trustedUrl">
        <Form.Label>Trusted URL</Form.Label>
        <Form.Control
          type="text"
          onChange={handleTrustedUrlChange}
          value={trustedUrl}
        />
      </Form.Group>
      <Form.Group controlId="appId">
        <Form.Label>App ID</Form.Label>
        <Form.Control type="text" onChange={handleAppIdChange} value={appId} />
      </Form.Group>
      <Form.Group controlId="appKey">
        <Form.Label>App Key</Form.Label>
        <Form.Control type="text" onChange={handleAppKeyChange} value={appKey} />
      </Form.Group>
      <Form.Group controlId="entityDomain">
        <Form.Label>Entity Domain</Form.Label>
        <Form.Control
          type="text"
          onChange={handleEntityDomainChange}
          value={entityDomain}
        />
      </Form.Group>
      <div
        className="btn btn-success btn-myed btn-success-myed"
        onClick={() => AddDevKey()}
      >
        <div className="fa-regular fa-plus fa-fw mr-2" /> Add Dev Key
      </div>
    </Fragment>
  )
}

DevKeyForm.propTypes = {
  organization: PropTypes.object.isRequired,
  setOrganization: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
}
